<section class="sg-card mb-4" 
    *ngIf="card">

    <mlp-ng-image 
        [title]="card.name" 
        [alt]="card.name" 
        [image]="card?.images" 
        class="sg-card__image sg-rounded mb-4"
    ></mlp-ng-image>

    <h2 class="sg-heading__h3 sg-card__title position-relative">
        <mlp-ng-icon *ngIf="card?.icon" class="sg-card__icon" size="medium" name="{{ card.icon }}"></mlp-ng-icon>
        {{ card.name }}
    </h2>

    <section class="sg-card__body">
        
        <p>{{ card.description }}</p>

        <ng-content></ng-content>

    </section>

</section>
    